(function () {
  document.addEventListener("DOMContentLoaded", function () {
    let swiperInstance = null;
    let resizeTimeout;

    function initSwiper() {
      const swiper = document.querySelector(".jdgm-rev-widg__body");
      if (!swiper) return; // Avoid unnecessary processing if element is not found

      // Add necessary classes if not already added
      if (!swiper.classList.contains("swiper")) swiper.classList.add("swiper");

      const wrapper = swiper.querySelector(".jdgm-rev-widg__reviews");
      if (wrapper && !wrapper.classList.contains("swiper-wrapper")) {
        wrapper.classList.add("swiper-wrapper");
      }

      const elements = document.querySelectorAll(".jdgm-rev");

      elements.forEach((element) => {
        if (!element.classList.contains("swiper-slide")) {
          element.classList.add("swiper-slide");
        }
      });

      // Only initialize Swiper if it's not already initialized
      if (window.innerWidth > 1200 && !swiperInstance) {
        swiperInstance = new Swiper(".jdgm-rev-widg__body", {
          spaceBetween: 28,
          freeMode: true,
          loop: true,
          slidesPerView: "auto",
          loopedSlides: 3,
          grabCursor: true,
          pagination: {
            el: ".jdgm-paginate",
            clickable: true,
          },
        });
      } else if (window.innerWidth <= 1200) {
        if (swiperInstance) {
          swiperInstance.destroy(true, true);
          swiperInstance = null;
        }

        swiperInstance = new Swiper(".jdgm-rev-widg__body", {
          spaceBetween: 28,
          freeMode: true,
          loop: true,
          slidesPerView: "auto",
          loopedSlides: 3,
          grabCursor: true,
          pagination: {
            el: ".jdgm-paginate",
            clickable: true,
          },
        });
      }
    }

    initSwiper();

    window.addEventListener("resize", function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(initSwiper, 200); // Debounce resize events
    });

    document.addEventListener("shopify:section:load", function () {
      initSwiper();
    });
  });
})();
